import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { collapse } from 'redux/modules/filters'

import CollapseHeader from 'components/Search/CollapseHeader'
import TopFilters from 'components/Search/Filters/TopFilters'
import { Column, Row } from 'components/v2/Grid'
import MoreFilters from 'components/v2/MoreFilters'
import ResultsController from 'components/v2/ResultsController'


const Filters = ({ onSearchPsychologists }) => {
  const dispatch = useDispatch()
  const filters = useSelector((state) => state.filters)

  const onToggleMoreFiltersVisibility = () => dispatch(collapse())

  useEffect(() => {
    const onScroll = () => {
      const wrapper = document.querySelector('#wrapper-header-search-filters')
      const fixedHeader = document.querySelector('#header-nav-bar')
      const collapseHeader = document.querySelector('#header-search-and-filters')
      const topFilters = document.querySelector('#top-filters')

      if (topFilters && window.location.pathname === '/busca') {
        const isCollapsed = filters?.collapsed
        const isCollapsedHeaderVisible = collapseHeader?.style.opacity === '1'

        if (window.pageYOffset > topFilters.offsetTop) {
          if (wrapper) wrapper.style.zIndex = '800'
          if (isCollapsed && !isCollapsedHeaderVisible) {
            onToggleMoreFiltersVisibility()
          }
          if (collapseHeader) collapseHeader.style.opacity = '1'
          if (fixedHeader) fixedHeader.style.visibility = 'hidden'
        } else {
          if (isCollapsed && isCollapsedHeaderVisible) {
            onToggleMoreFiltersVisibility()
          }
          if (fixedHeader) fixedHeader.style.visibility = 'visible'
          if (collapseHeader) collapseHeader.style.opacity = '0'
          if (wrapper) wrapper.style.zIndex = '-1'
        }
      }
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', onScroll)
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', onScroll)
      }
    }
  }, [filters?.collapsed])

  return (
    <div>
      <CollapseHeader />
      <Column>
        <Row as='section' id='default-filters' className='justify-center mb-[3px] bg-white'>
          <TopFilters onSearchPsychologists={onSearchPsychologists} />
          {filters?.collapsed && <MoreFilters onSearchPsychologists={onSearchPsychologists} />}
        </Row>
        <Row className='justify-center bg-[#f8f8f8] flex-nowrap sm:flex-wrap'>
          <Row as='section' className='px-[15px] sm:px-2.5 w-full sm:w-[1140px] bg-[#f8f8f8]'>
            <ResultsController />
          </Row>
        </Row>
      </Column>
    </div>
  )
}

export default Filters
